import { PureComponent } from 'react';

class MergeVarsDecorator extends PureComponent {
  render() {
    const { children, contentState, entityKey, mergeVarsConfig, readOnly } = this.props;
    const { defaultValue, name } = contentState.getEntity(entityKey).getData();
    if (readOnly) {
      const value = (mergeVarsConfig || {})[name] || defaultValue;
      return <span>{value}</span>;
    }
    return (
      <>
        <span css={cursorHolderCss}>{children}</span>
        <span contentEditable={false} css={tagCss}>
          {defaultValue || name}
        </span>
      </>
    );
  }
}

const cursorHolderCss = {
  width: 0,
  display: 'inline-block',
};
const tagCss = ({ palette }) => ({
  display: 'inline-block',
  backgroundColor: palette.primary.main,
  color: palette.primary.contrastText,
  borderRadius: 4,
  padding: 2,
});

export default {
  strategy: (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(character => {
      const entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'MERGE_VAR';
    }, callback);
  },
  component: MergeVarsDecorator,
};
